export default __webpack_public_path__ + "static/media/map.968eddb7.png";